'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('./helpers/util');

var _isValid = require('./isValid');

var _isValid2 = _interopRequireDefault(_isValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @flow weak
exports.default = function (dates) {
  return (0, _util.any)(_isValid2.default, dates) ? (0, _util.find)(Math.max, dates) : new Date('invalid');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/max.js
// module id = 1404
// module chunks = 0 1 2 3 4 5 7 8 9